module.exports = __webpack_public_path__ + "assets/img/logo3.e649b5a7.png";